import { ReactComponent as OutsideLinkIcon } from './outside_link.svg';

export default OutsideLinkIcon;
